import React from 'react'
import AuditInitialize from '../AuditInitialize'
// @TODO Remove when app is combined.
import 'font-awesome/css/font-awesome.min.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-confirm-alert/src/react-confirm-alert.css'
import '../../styles/Audit.scss'
import AuditRoutes from './Routes'
import BarcodeToastMessage from '../BarcodeToastMessage'

function Audit(props) {
  return (
    <AuditInitialize>
      <BarcodeToastMessage />
      <AuditRoutes />
    </AuditInitialize>
  )
}

export default Audit
